import { render, staticRenderFns } from "./circulardetails.vue?vue&type=template&id=01c261ab&scoped=true&"
import script from "./circulardetails.vue?vue&type=script&lang=js&"
export * from "./circulardetails.vue?vue&type=script&lang=js&"
import style0 from "./circulardetails.vue?vue&type=style&index=0&id=01c261ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c261ab",
  null
  
)

export default component.exports